import { Badge } from '@shopify/polaris';
//email sent badge
export const emailSentBadge = (Verstuurd) => {
  const result = Verstuurd ? <Badge tone="success">Sent</Badge> : <Badge tone="warning">Not sent</Badge>;
  return result;
};
